import b from "./_common.js";
import { createTheme as x } from "../../_mixins/use-theme.js";
import S from "../../_styles/common/light.js";
import g from "../../select/styles/light.js";
import h from "../../input/styles/light.js";
import f from "../../popselect/styles/light.js";
function v(n) {
  const {
    textColor2: o,
    primaryColor: t,
    primaryColorHover: s,
    primaryColorPressed: d,
    inputColorDisabled: a,
    textColorDisabled: r,
    borderColor: e,
    borderRadius: p,
    // item font size
    fontSizeTiny: i,
    fontSizeSmall: m,
    fontSizeMedium: l,
    // item size
    heightTiny: u,
    heightSmall: C,
    heightMedium: c
  } = n;
  return Object.assign(Object.assign({}, b), {
    buttonColor: "#0000",
    buttonColorHover: "#0000",
    buttonColorPressed: "#0000",
    buttonBorder: `1px solid ${e}`,
    buttonBorderHover: `1px solid ${e}`,
    buttonBorderPressed: `1px solid ${e}`,
    buttonIconColor: o,
    buttonIconColorHover: o,
    buttonIconColorPressed: o,
    itemTextColor: o,
    itemTextColorHover: s,
    itemTextColorPressed: d,
    itemTextColorActive: t,
    itemTextColorDisabled: r,
    itemColor: "#0000",
    itemColorHover: "#0000",
    itemColorPressed: "#0000",
    itemColorActive: "#0000",
    itemColorActiveHover: "#0000",
    itemColorDisabled: a,
    itemBorder: "1px solid #0000",
    itemBorderHover: "1px solid #0000",
    itemBorderPressed: "1px solid #0000",
    itemBorderActive: `1px solid ${t}`,
    itemBorderDisabled: `1px solid ${e}`,
    itemBorderRadius: p,
    itemSizeSmall: u,
    itemSizeMedium: C,
    itemSizeLarge: c,
    itemFontSizeSmall: i,
    itemFontSizeMedium: m,
    itemFontSizeLarge: l,
    jumperFontSizeSmall: i,
    jumperFontSizeMedium: m,
    jumperFontSizeLarge: l,
    jumperTextColor: o,
    jumperTextColorDisabled: r
  });
}
const z = x({
  name: "Pagination",
  common: S,
  peers: {
    Select: g,
    Input: h,
    Popselect: f
  },
  self: v
}), D = z;
export {
  D as default,
  v as self
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/pagination/styles/light.js
// module id = 927
// module chunks = 41